// Shared helpers for Landing sections
import React from "react";

export const MXN = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
  maximumFractionDigits: 0,
});

export const STAGE_CLS = {
  "Disponible": "stage-disponible",
  "Evaluación privada": "stage-review",
  "En revisión privada": "stage-review",
  "En documentación": "stage-documentacion",
  "Próximo a completar": "stage-proximo",
  "Capital completado": "stage-completado",
};

export const SUC_ESTADO = {
  confirmado: { label: "Confirmada", cls: "text-emerald-700 bg-emerald-500/10" },
  en_operacion: { label: "Ya abrió", cls: "text-[#0A0A0A] bg-[#FFBF57]/20" },
  en_remodelacion: { label: "Próxima apertura", cls: "text-[#B8862F] bg-[#FFBF57]/10" },
  en_negociacion: { label: "En negociación", cls: "text-[#52525B] bg-black/[0.05]" },
  en_documentacion: { label: "En documentación", cls: "text-sky-700 bg-sky-500/10" },
  prospectada: { label: "Prospectada", cls: "text-[#52525B] bg-black/[0.04]" },
};

export function StageBadge({ stage }) {
  const cls = STAGE_CLS[stage] || "stage-neutral";
  return (
    <span className={`stage-badge ${cls}`}>
      <span className="dot" />
      {stage}
    </span>
  );
}

export function renderTitle(text) {
  if (!text) return null;
  const parts = text.split(/(<em>[^<]*<\/em>)/g);
  return parts.map((p, i) => {
    const m = p.match(/^<em>([^<]*)<\/em>$/);
    if (m) return <span key={i} className="accent">{m[1]}</span>;
    return <span key={i}>{p}</span>;
  });
}

export function toFullUrl(u) {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  if (u.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL || ""}${u}`;
  return u;
}

export function Detail({ label, value, full = false }) {
  return (
    <div className={full ? "col-span-2" : ""}>
      <div className="text-[9px] uppercase tracking-widest text-[#52525B] font-mono mb-0.5">{label}</div>
      <div className="text-[13px] text-[#0A0A0A]">{value}</div>
    </div>
  );
}
